import { UserPermissionsService } from './services/UserPermissionsService';
import type { Init } from './types';
import { managerHelpers } from '../../helpers';
import type { MergedDataReturnType, MergedHandlersReturnType } from '../../types';
import { WithApi } from '../WithApi';

export * from './UserPermissionBannerManager';

export type UserPermissionBannerData = MergedDataReturnType<[UserPermissionsService]>;

export type UserPermissionBannerHandlers = MergedHandlersReturnType<[UserPermissionsService]>;

type TApi = ReturnType<UserPermissionsService['api']>;

export class UserPermissionBannerManager extends WithApi<TApi> {
  public userPermissionBannerInit = ({ t, queries }: Init) => {
    const [extendedBillingAccountQuery, userRoleQuery] = queries;

    const pending = extendedBillingAccountQuery.isPending || userRoleQuery.isPending;
    const error = extendedBillingAccountQuery.error || userRoleQuery.error;

    if (pending) {
      return {
        status: 'pending',
        data: null,
        handlers: null,
      } as const;
    }

    if (error) {
      return {
        status: 'error',
        data: error,
        handlers: {
          retry: () => {
            managerHelpers.retryQueries(queries);
          },
        },
      } as const;
    }

    const userPermissions = new UserPermissionsService(extendedBillingAccountQuery.data, userRoleQuery.data, t);

    this.initApi({
      ...userPermissions.api(),
    });

    return {
      status: 'loaded',
      data: {
        ...userPermissions.data(),
      },
      handlers: {
        ...userPermissions.handlers(),
      },
    } as const;
  };
}
